import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    if (import.meta.env.DEV) {
      console.error("[ErrorBoundary]", error, info.componentStack);
    }
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <main className="app-page" style={{ paddingTop: 40, textAlign: "center" }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, margin: "0 0 8px" }}>
            Что-то пошло не так
          </h2>
          <p style={{ color: "var(--color-muted)", margin: "0 0 20px" }}>
            Попробуйте перезагрузить страницу
          </p>
          <button
            className="btn-primary"
            onClick={() => window.location.reload()}
            type="button"
          >
            Перезагрузить
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
